import { TInfoMessage, TUser } from "../comonTypes"

export enum EAppState {
    SET_INFO_MESSAGE = 'message',
    SET_TOKEN = 'token'
}

export interface IAppState {
    [EAppState.SET_INFO_MESSAGE]?: TInfoMessage,
    [EAppState.SET_TOKEN]?: string
}